import { createContext, useContext, type ReactNode } from 'react';
import type {
  DesignPointResponse,
  GeometryResponse,
  StudyDetailResponse,
} from '@/api/generated/types.gen';
import type { DpDetailTab } from '../-data/constants';

export interface StudyContextValue {
  study: StudyDetailResponse;
  designPoints: DesignPointResponse[];
  geometries: GeometryResponse[];
  selectedDpId: string | undefined;
  detailTab: DpDetailTab | undefined;
  onSelectDp: (next: { dp?: string; tab?: DpDetailTab } | null) => void;
}

const StudyContext = createContext<StudyContextValue | null>(null);

export function StudyContextProvider({
  value,
  children,
}: {
  value: StudyContextValue;
  children: ReactNode;
}) {
  return (
    <StudyContext.Provider value={value}>{children}</StudyContext.Provider>
  );
}

export function useStudyContext(): StudyContextValue {
  const ctx = useContext(StudyContext);
  if (!ctx) {
    throw new Error('useStudyContext must be used within StudyContextProvider');
  }
  return ctx;
}
